module.exports = __webpack_public_path__ + "static/assets/dcbb1044bb98b94ab22056f47ff354c3.svg";